import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ClientDocumentRow {
  dd: string;
  rb: string;
  ug: string;
}

export interface AuditMailPayload {
  toEmail: string[];
  subject: string;
  messageBody: string;
  sharableUrl: unknown;
  files: unknown;
  data: unknown;
  cannedText: string;
  shareType?: string;
  lanIds?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private http = inject(HttpClient);

  tab = 1;


  uploadDocument(formData: any){
    return this.http.post(environment.apiUrl + "document/upload",formData)
  }

  fetchFiles(adminId: any, recordId: any) {
    return this.http.get(environment.apiUrl + 'fetch/files?adminId='+adminId+'&recordId='+recordId);
  }

  downloadDocument(fileName: any){
    return this.http.get(environment.apiUrl+"document/download/"+fileName,{responseType: 'arraybuffer'})
  }

  deleteDocument(id: any){
    return this.http.post(environment.apiUrl+"document/delete",{"id":id})
  }

  checkLockStatus(adminId: any, type: any){
    return this.http.post(environment.apiUrl+"audit/edit/check",{"id":adminId, type:type})
  }

  requestLinkToken(data: any){
    const res = this.http.post(environment.apiUrl+"request/post/token",JSON.parse(JSON.stringify(data)));
    return res;
  }

  requestFollowUpToken(SelectRow: any){
    const res = this.http.post(environment.apiUrl+"request/post/FollowUptoken",JSON.parse(JSON.stringify(SelectRow)));
    return res;
  }
  requestISRToken(data: any){
    const res = this.http.post(environment.apiUrl+"request/post/InvestigativeSummary",data);
    return res;
  }

  getApiUrl(){
    return environment.apiUrl
  }

  sendMail(toEmail: any, subject: any, messageBody: any, sharableUrl: any, files: any, data: any, cannedText: any, shareType?: string, lanIds?: string[]){
    const payload: AuditMailPayload = {toEmail, subject, messageBody, sharableUrl, files, data, cannedText};
    if (shareType) {
      payload.shareType = shareType;
    }
    if (lanIds && lanIds.length > 0) {
      payload.lanIds = lanIds;
    }
    return this.http.post(environment.apiUrl+"audit/mail", payload);
  }

  generatePDF(data: any){
    const res = this.http.post(environment.apiUrl+"generate/pdf",data);
    return res
  }

  loadDocuments(){
    return this.http
      .get<unknown>(environment.apiUrl + 'client/document/')
      .pipe(
        map((res: unknown) => Array.isArray(res) ? (res as ClientDocumentRow[]) : []),
        catchError(() => of([]))
      );
  }
}
